import { customStyle, customStyleLight } from "./CustomStyle";
import { useEffect, useContext, useState } from "react";
import ActivityIndicator from "../activityIndicator/ActivityIndicator";
import AuthContext from "../../context/AuthContext";
import axios from "axios";
import InputHeader from "../input/InputHeader";
import ReactSelect, { createFilter } from "react-select";
import styles from "./Dropdowns.module.css";
import InputCard from "../containers/InputCard";
import InfoLabel from "../labels/InfoLabel";
import ThemeContext, { themes } from "../../context/ThemeContext";

const Dropdown = ({
  value,
  selectHandler,
  identifier,
  title,
  url,
  noOptionsMessage,
  fetchingMessage,
  convertOptionsHandler,
  bodyObject = {},
  dependencies = [],
  required = false,
}) => {
  const authCtx = useContext(AuthContext);
  const themeCtx = useContext(ThemeContext);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [options, setOptions] = useState();

  useEffect(() => {
    setLoading(true);
    // Clean up async useEffect flag.
    let isSubscribed = true;
    let authObj = { headers: { Authorization: `token ${authCtx.token}` } };
    axios
      .post(url, bodyObject, authObj)
      .then((response) => {
        if (isSubscribed) {
          // Convert options to useable react-select data.
          let options = convertOptionsHandler(response?.data);
          if (!options || options?.length === 0) {
            setStatus(noOptionsMessage);
            setLoading(false);
            return;
          }
          setStatus("");
          setOptions(options);
          setLoading(false);
        }
      })
      .catch((error) => {
        if (isSubscribed) {
          setStatus(
            error?.response?.data
              ? `Error: ${error.response.data}`
              : error?.message
              ? `Error: ${error.message}`
              : `Error: ${error}`
          );
          setLoading(false);
        }
      });
    // Cancel subscription to useEffect.
    return () => (isSubscribed = false);
    //eslint-disable-next-line
  }, [authCtx.token, ...dependencies]);

  let dropdownStyle =
    themeCtx.currentTheme() === themes.light ? customStyleLight : customStyle;

  return (
    <InputCard>
      <ActivityIndicator text={fetchingMessage} loading={loading} />
      {!loading && !status && options?.length > 0 && (
        <>
          <InputHeader text={title} required={required} />
          <ReactSelect
            className={styles.dropdown}
            value={value}
            onChange={selectHandler}
            options={options}
            filterOption={createFilter({ ignoreAccents: false })}
            styles={dropdownStyle}
            name={identifier}
            id={identifier}
          />
        </>
      )}
      {status && (
        <>
          <InputHeader text={title} />
          <InfoLabel identifier={identifier} text={noOptionsMessage} />
        </>
      )}
    </InputCard>
  );
};

export default Dropdown;
